export function subscribeOnce(callback, evaluator) {
    let subscription = this.subscribe(function (value) {
        if (!evaluator || evaluator(value)) {
            subscription.dispose();
            subscription = null;
            callback(value);
        }
    });
}

export function subscribeObservables(source, target, func) {
    let sourceObservable = ko.isObservable(source) ? source : ko.computed(function () { return source()(); });
    let isTargetObservable = ko.isObservable(target);

    let callback = function (value) {
        if (func) {
            value = func(value);
        }

        let targetObservable = isTargetObservable ? target : target();
        let targetValue = targetObservable();

        if (targetValue !== value) {
            targetObservable(value);
        }
    };

    callback(sourceObservable());

    return sourceObservable.subscribe(callback);
}

export function compare(a, b) {
    if (a === b) {
        return true;
    }

    if (isPrimitive(a)) {
        return comparePrimitive(a, b);
    }

    if (isArray(a)) {
        return compareArray(a, b);
    }

    return compareObject(a, b);
}

let primitiveTypes = { 'undefined': 1, 'boolean': 1, 'number': 1, 'string': 1 };

function isPrimitive(a) {
    return a == null || typeof (a) in primitiveTypes;
}

function isArray(a) {
    return _.isArray(a);
}

function comparePrimitive(a, b) {
    if (a == null || b == null) {
        return false;
    }

    return a === b;
}

function compareArray(a, b) {
    if (a == null || b == null) {
        return false;
    }

    if (a.length === 0 || b.length === 0) {
        return false;
    }

    if (a.length !== b.length) {
        return false;
    }

    for (let i = 0; i < a.length; i++) {
        if (compare(a[i], b[i]) === false) {
            return false;
        }
    }

    return true;
}

function compareObject(a, b) {
    if (a == null || b == null) {
        return false;
    }

    if (a.isDisposed === true || b.isDisposed === true) {
        return false;
    }

    if (_.keys(a).length === 0 && _.keys(b).length === 0) {
        return false;
    }

    if (a instanceof jQuery || b instanceof jQuery) {
        return false;
    }

    if (a.equalityComparer != null) {
        let pickA = a.equalityComparer();

        if (b.equalityComparer == null) {
            return false;
        }

        let pickB = b.equalityComparer();
        if (pickA == null || pickB == null) {
            return false;
        }

        return comparePrimitive(JSON.stringify(pickA), JSON.stringify(pickB));
    }

    if (typeof a === 'object') {
        try {
            return comparePrimitive(JSON.stringify(a), JSON.stringify(b));
        } catch (e) {
            return false;
        }
    }

    return false;
}

export default {
    compare,
    subscribeObservables,
    subscribeOnce
}